module.exports = __webpack_public_path__ + "static/media/alert-circle.91b70019.svg";